import { useEffect, useState } from 'react';
import { fetchDemoContext224, type DemoContext224 } from '../services/demoModeApi';
import { useAppStore } from '../store/AppStore';

const EMPTY: DemoContext224 = { demo: false, dataMode: 'real', restrictedFeatures: [] };

/**
 * Whether the signed-in session belongs to a demo tenant.
 *
 * Keyed on the session, because this is read once at the app root: fetching
 * only on mount meant the banner was decided before the demo sign-in happened
 * and never corrected afterwards.
 */
export function useDemoContext224(): DemoContext224 {
  const { state } = useAppStore();
  const sessionKey = `${state?.session.userId ?? ''}:${state?.session.role ?? ''}`;
  const [context, setContext] = useState<DemoContext224>(EMPTY);
  useEffect(() => {
    let active = true;
    if (!state?.session.authenticated) { setContext(EMPTY); return () => { active = false; }; }
    void fetchDemoContext224().then((next) => { if (active) setContext(next); });
    return () => { active = false; };
  }, [sessionKey, state?.session.authenticated]);
  return context;
}
